import { useEffect, useState } from "react";
import type { ClinicJourney } from "@ferrivia/api-contract";
import { useApi } from "@ferrivia/auth-web";

export type CustomerJourneyState =
  | { status: "loading" }
  | { status: "error"; error: string }
  | { status: "success"; journey: ClinicJourney };

/* No cache and no polling, for the same reason useCustomerLabs has none —
   and here too that is a compliance property rather than an economy. Every
   call writes an asiakastietolaki 10 § käyttöloki row naming the staff
   member who read this customer's journey (see
   apps/api/src/modules/journey/clinic-store.ts). A background refresh would
   put entries in that register that no clinician actually performed, which
   makes the register less truthful, not more complete. One fetch per time
   the pane is opened, which is exactly the disclosure that happened. */
export function useCustomerJourney(id: string | undefined): CustomerJourneyState {
  const api = useApi();
  const [state, setState] = useState<CustomerJourneyState>({ status: "loading" });

  useEffect(() => {
    if (!id) {
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    api.patients
      .journey(id)
      .then((journey) => {
        if (!cancelled) {
          setState({ status: "success", journey });
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setState({ status: "error", error: err instanceof Error ? err.message : "Failed to load journey" });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [api, id]);

  return state;
}
